import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import { useHarvestingContext } from 'src/views/harvesting/harvesting-context';
import { usePreferenceContext} from 'src/context/PreferenceContext';
import TabWithNumber from './tab-with-number';
import {FruitStatusType} from 'src/views/harvesting/fruit-profile/model';
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    '& .MuiTabs-indicator, .MuiTab-root': {
      minWidth: '0px !important',
      'padding-inline': '20px',
    },
    marginBottom: 2,
  },
});
const fishStatus ={
  'Available':0,
  'Texted':1,
  'Filtered':2,
  'Blacklisted':3,
  'All':4,
  'Removed':5,
 
};


export default function FishStatusTabs() {
  const classes = useStyles();
  const {availableCount, textedCount, filteredCount,blacklistedCount, allCount,removedCount} = useHarvestingContext();
  const {fruitsTab,setFruitsTab} = usePreferenceContext();
  const [value, setValue] = React.useState(fishStatus[fruitsTab]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (event: any, newValue: number) => {
    // setValue(newValue);
    setFruitsTab(Object.keys(fishStatus)[newValue] as FruitStatusType);
  };
  
  return (
    <Paper className={classes.root}>
      <Tabs
        value={fishStatus[fruitsTab]}
        onChange={(event, newValue)=>handleChange(event, newValue)}
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        textColor="primary"
      >
        <TabWithNumber
          label="Available"
          // disableNumber
          number={availableCount}
        />
        <TabWithNumber
          label="Texted"
          number={textedCount}
        />
        <TabWithNumber
          label="Filtered"
          // disableNumber
          number={filteredCount}
        />
        <TabWithNumber
          label="Blacklisted"
          number={blacklistedCount}
        />
        <TabWithNumber
          label="All"
          number={allCount}
        />
        <TabWithNumber
          label="Removed"
          number={removedCount}
        />
     
      </Tabs>
    </Paper>
  );
}
